import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EditComponent } from '../edit-component'
import { CatalogueEntry } from '../../../models/catalogue'

@Component({
  selector: 'jml-lib-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  styleUrls: ['./dropdown-input.component.scss']
})
export class DropdownInputComponent extends EditComponent {
  @Input() selectedEntry: CatalogueEntry
  @Input() labelProperty = 'name'
  @Input() options: CatalogueEntry[]
  @Input() placeholder: string
  @Input() appendTo = 'body'
  @Input() showLabel = true
  @Input() showIcon = false
  @Input() showTooltip = false
  @Input() showDelete = false

  @Output() selectedEntryChange = new EventEmitter<CatalogueEntry>()
  @Output() onDelete: EventEmitter<void> = new EventEmitter()

  onChange() {
    this.control.setValue(this.selectedEntry.id)
    this.selectedEntryChange.emit(this.selectedEntry)
    this.emitUpdate()
  }

  onClickDelete() {
    this.control.setValue(null)
    this.selectedEntry = null
    this.onDelete.emit()
    this.emitUpdate()
  }
}
